module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('App-SideMenu'), _vm._v(" "), _c('main', {
    staticClass: "cd-main-content landing-color"
  }, [_c('div', {
    staticClass: "landing-main-content"
  }, [_c('div', {
    staticClass: "book-bg"
  }, [_c('div', {}, [_c('div', {
    staticClass: "wrapper-square"
  }, [_c('form', {
    staticClass: "login-form-wrapper"
  }, [_c('div', {
    staticClass: "login-form-content"
  }, [_c('h1', [_vm._v("Register New Account")]), _vm._v(" "), _c('div', {
    staticClass: "login-input-containers"
  }, [_c('h3', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold"
    }
  }, [_vm._v("EMAIL")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "email",
      "placeholder": "Email",
      "required": ""
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "login-input-containers"
  }, [_c('h3', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold"
    }
  }, [_vm._v("FULL NAME")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fullname),
      expression: "fullname"
    }],
    attrs: {
      "type": "texts",
      "placeholder": "Name",
      "required": ""
    },
    domProps: {
      "value": (_vm.fullname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fullname = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "login-input-containers"
  }, [_c('h3', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold"
    }
  }, [_vm._v("PASSWORD")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "Password",
      "required": ""
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "login-input-containers"
  }, [_c('h3', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold"
    }
  }, [_vm._v("RECONFIRM PASSWORD")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Cpassword),
      expression: "Cpassword"
    }],
    attrs: {
      "type": "password",
      "placeholder": "Password",
      "required": ""
    },
    domProps: {
      "value": (_vm.Cpassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.Cpassword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "login-input-containers"
  }, [_c('h3', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold"
    }
  }, [_vm._v("Gender")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gender),
      expression: "gender"
    }],
    attrs: {
      "type": "radio",
      "name": "Gender",
      "value": "Male",
      "required": "",
      "checked": ""
    },
    domProps: {
      "checked": _vm._q(_vm.gender, "Male")
    },
    on: {
      "change": function($event) {
        _vm.gender = "Male"
      }
    }
  }), _vm._v(" Male\n                  "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gender),
      expression: "gender"
    }],
    attrs: {
      "type": "radio",
      "name": "Gender",
      "value": "Female",
      "required": ""
    },
    domProps: {
      "checked": _vm._q(_vm.gender, "Female")
    },
    on: {
      "change": function($event) {
        _vm.gender = "Female"
      }
    }
  }), _vm._v(" Female\n                  "), _c('br')]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "pointer",
    attrs: {
      "id": "login-register-btn"
    },
    on: {
      "click": function($event) {
        _vm.handleSignUp()
      }
    }
  }, [_vm._v("Sign Up")]), _vm._v(" "), _vm._m(0, false, false)])])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "login-signup-link"
    }
  }, [_c('h3', [_vm._v("By register this account, you already accepted our terms and agreement. \n                ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5bcf2624"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/register.vue
// module id = 1695
// module chunks = 1